import {Helmet} from '@dr.pogodin/react-helmet';

import {useEffect} from 'react';

import {tenantApi} from '@dms/api/core';
import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';
import {useThunkDispatch} from '@dms/teas';

import {useBoolean} from 'shared/web';

import {VehicleServicesList} from './components/VehicleServicesList';

export function VehicleServices() {
  const dispatch = useThunkDispatch();

  const [isLoading, startLoading, stopLoading] = useBoolean(false);

  useEffect(
    function loadCebiaRokvyConfig() {
      startLoading();
      dispatch(tenantApi.endpoints.getCebiaRokvyConfig.initiate()).finally(() => {
        stopLoading();
      });
    },
    [dispatch, startLoading, stopLoading]
  );

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.integrations.labels.vehicleServices'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        isLoading={isLoading}
        header={{title: i18n.t('page.integrations.labels.vehicleServices')}}
        data-testid="integrations-vehicle-settings"
      >
        <VehicleServicesList />
      </SettingsTemplate>
    </>
  );
}
